import { useEffect, useRef } from "react";
import { matchPath, useLocation } from "react-router-dom";

import { Routes } from "constants/routes";
import { defaultMeasureDataTableFilters } from "constants/measure-data";
import { useNavigationHooks } from "hooks/shared-hooks/use-navigation-hooks";
import { isEqual } from "lodash";
import { useMonitoringDataFilters } from "store";

// Sync the monitoring data-tab filters into the URL `dataOperations` param.
// Skips the first run so we don't clobber a URL the consumer just hydrated from.
export const useDataOperationsQueries = (): void => {
  const { pathname } = useLocation();
  const dataFilters = useMonitoringDataFilters();
  const { setParams, removeParams } = useNavigationHooks();
  const skipFirstRunRef = useRef<boolean>(true);

  useEffect(() => {
    if (skipFirstRunRef.current) {
      skipFirstRunRef.current = false;
      return;
    }
    if (!matchPath(pathname, Routes.monitoringData)) return;

    if (isEqual(dataFilters, defaultMeasureDataTableFilters)) {
      removeParams(["dataOperations"]);
    } else {
      setParams({ search: { dataOperations: JSON.stringify(dataFilters) } });
    }
  }, [dataFilters, pathname]);
};
